import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import ActionButton from "../../Common/ActionButton";
// api
import { Signle_Call } from "../../Api/Api";
import { Fragment } from "react";
import Button from "@material-ui/core/Button";
import Popup from "../Popup";
import { Rating } from "react-simple-star-rating";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const Comments = (props) => {
  const [rating, setRating] = useState(0);
  const [value, setValue] = useState(0);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [state, setState] = useState({
    validation: false,
    popupStatus: false,
    sendCommentTitle: "",
    loading: false,
  });
  const handleRating = (rate) => {
    setRating(rate);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getComments_apiCall = async () => {
    const apiCall = () => {

      const apiCall = async (tools) => {
        const ApiCall = await Signle_Call(tools);
        return ApiCall;
      };
      return new Promise((result) => {
        result(
          apiCall({
            method: "get",
            data: false,
            path: `item_comment/${props.id}`,

          })
        );
      });
    };
    const result = await apiCall();
    result.type && setComments(result.response.data.itemComments.reverse());
  };

  const send_comment = async () => {
    setState({
      ...state,
      loading: true,
    });
    if (newComment.length <= 5) {
      setState({
        ...state,
        validation: true,
      });
    } else {
      const apiCall = () => {

        const DATA = {
          item_id: props.id,
          comment: newComment,
          rate: rating / 20,
        };
        const apiCall = async (tools) => {
          const ApiCall = await Signle_Call(tools);
          return ApiCall;
        };
        return new Promise((result) => {
          result(
            apiCall({
              method: "post",
              data: DATA,
              path: `item_comment`,

            })
          );
        });
      };
      const result = await apiCall();
      if (result.type == 1) {
        setState({
          ...state,
          sendCommentTitle: result.response.data[0],
          popupStatus: true,
          validation: false,
        });
        setNewComment("");
      }
    }
  };

  const closePopup = () => {
    setState({
      ...state,
      popupStatus: false,
    });
  };

  useEffect(() => {
    getComments_apiCall();
  }, []);
  return (
    <Fragment>
      {props.data.comment_status ? (
        <div className="Comments col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <Popup active={state.popupStatus}>
            <div className="comment-popup">
              <h4>{state.sendCommentTitle}</h4>
              <Button variant="contained" onClick={closePopup}>
                تایید
              </Button>
            </div>
          </Popup>
          <div className="Comments_wrapper col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div className="tabHeader">
              <AppBar position="static">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="simple tabs example"
                >
                  <Tab label="نظرات کاربران" {...a11yProps(0)} />
                  <Tab label="نظر دهی" {...a11yProps(1)} />
                </Tabs>
              </AppBar>
            </div>
            <div className="tabBody">
              <TabPanel value={value} index={0}>
                {comments.length > 0 ? (
                  <div className="item-comment">
                    {comments.map((item, item_index) => (
                      <div key={item_index} className="item-comment">
                        <Fragment>
                          <div
                            className="style-cmnt"
                            key={item.id ? item.id : item_index}
                          >
                            <div className="pic">
                              <img src={item.user_photo} />
                            </div>
                            <div className="cntnt">
                              <div className="cm">
                                <h4>{item.user_name}</h4>
                                <div className="rate">
                                  <span>{item.rate}</span>
                                  <i className="icon-black-star-silhouette"></i>
                                </div>
                              </div>
                              <p>{item.comment}</p>
                              <span>{item.date}</span>
                            </div>
                          </div>
                          {item.has_reply ? (
                            <div className="style-cmnt admin-cmnt">
                              <div className="pic">
                                <img src={item.reply.user_photo} />
                              </div>
                              <div className="cntnt">
                                <h4>{item.reply.user_name}</h4>
                                <p>{item.reply.comment}</p>
                                <span>{item.reply.date}</span>
                              </div>
                            </div>
                          ) : null}
                        </Fragment>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-content">
                    <i className="icon-comment"></i>
                    <span>{props.cmntPlaceholder}</span>
                  </div>
                )}
              </TabPanel>
              <TabPanel value={value} index={1}>
                <div className="add_comment_wrapper col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="input_wrapper col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <TextField
                      id="filled-multiline-static"
                      label="متن  خود را بنویسید"
                      multiline
                      rows={4}
                      fullWidth={true}
                      defaultValue=""
                      variant="filled"
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                    />
                    <div className="rating">
                      <div className="ratingTitle">امتیاز</div>
                      <Rating
                        onClick={handleRating}
                        value={rating}
                        ratingValue={rating}
                        
                        /* Available Props */
                      />
                    </div>
                    <span
                      className={`error-text ${
                        newComment.length <= 5 && state.validation
                          ? "active"
                          : ""
                      }`}
                    >
                      لطفا نظر خود را وارد کنید{" "}
                      <i className="icon-exclamation-mark"></i>
                    </span>
                  </div>
                  <ActionButton
                    WhiteMode={false}
                    OnLoadMode={state.loading}
                    DisableMode={false}
                    ClassNames={["sendComment_button"]}
                    DisableOnLoadMode={true}
                    Text={"ثبت نظر"}
                    DoAction={() => send_comment()}
                    Type={false}
                  />
                </div>
              </TabPanel>
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

export default Comments;
